import relativeInfoReducer from "./reducers";
export { default as relativeInfoTypes } from "./types";
export { default as relativeInfoOperations } from "./operations";
export default relativeInfoReducer;
